module.exports = __webpack_public_path__ + "img/carpark_select.8a24a675.png";